/* ==========================================================================
   Lockett Labs: Pokémon TCG coins (assets/ll-coins.js)

   Behaviour for sections/ll-coins.liquid. The coins themselves are rendered
   in Liquid; this reads them back from the grid (data-* on each tile), works
   out what each coin is from its variant title, and adds:

     1  setup, money, icons
     2  what a coin is: subject, size, finish, colour, energy type, series
     3  filters: search, subject, name, size, finish, type, price, stock, sort,
        with counts that answer "how many if I tick this", kept in the URL
     4  picks: choose designs and quantities, kept for the visit, one add
     5  the picks tray, and a picked coin flying into it
     6  the viewer: the coin in 3D (drag to turn, flip it), details, buying,
        more like this, previous and next, ?variant= deep links
     7  heading art
     8  watch, toasts, the human check (shared with the product page)

   Idle cost: nothing runs while the page sits still. Motion is limited to the
   moment something happens (a pick, a flip, the viewer opening), and
   everything turns to a plain state change under prefers-reduced-motion.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-llcn]');
  if (!root) return;
  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-llcn-cfg]').textContent); } catch (e) {}
  var P = cfg.product || {};
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  var grid = root.querySelector('[data-grid]');
  if (!grid) return;

  /* ---------------------------------------------------------------- 1 setup */
  function $(s, c) { return (c || root).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function norm(s) {
    s = String(s || '').toLowerCase();
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
    return s.replace(/[^a-z0-9&'+ -]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function cap(s) { s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1); }
  function formatMoney(cents) {
    var fmt = cfg.money_format || '£{{amount}}';
    var n = (cents / 100);
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/), val;
    function fixed(p, t, d) {
      var parts = n.toFixed(p).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (parts[1] ? d + parts[1] : '');
    }
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': val = fixed(0, ',', '.'); break;
      case 'amount_with_comma_separator': val = fixed(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = fixed(0, '.', ','); break;
      default: val = fixed(2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, val);
  }
  var ICON = {
    x: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.4 5 12 10.6 17.6 5 19 6.4 13.4 12l5.6 5.6-1.4 1.4-5.6-5.6L6.4 19 5 17.6l5.6-5.6L5 6.4z"/></svg>',
    plus: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M11 5h2v6h6v2h-6v6h-2v-6H5v-2h6z"/></svg>',
    minus: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 11h14v2H5z"/></svg>',
    bin: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 3h6l1 2h4v2H4V5h4Zm-3 6h12l-.9 11.1A2 2 0 0 1 15.1 22H8.9a2 2 0 0 1-2-1.9Zm4 2v8h1.6v-8Zm2.4 0v8H14v-8Z"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M13.2 5.4 20 12l-6.8 6.6-1.4-1.45L16 13H4v-2h12l-4.2-4.15z"/></svg>',
    left: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15.4 5.4 16.8 7l-5 5 5 5-1.4 1.6L9 12z"/></svg>',
    right: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m8.6 5.4 6.4 6.6-6.4 6.6L7.2 17l5-5-5-5z"/></svg>',
    up: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 8.6 6.6 6.4-1.6 1.4-5-5-5 5-1.6-1.4z"/></svg>',
    tick: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9.5 16.2-4.2-4.2-1.4 1.4 5.6 5.6 11-11-1.4-1.4z"/></svg>',
    check: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Zm4.3 6.3-5.8 5.8-2.8-2.8-1.4 1.4 4.2 4.2 7.2-7.2Z"/></svg>',
    warn: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2 1 21h22Zm-1 7h2v5h-2Zm0 7h2v2h-2Z"/></svg>',
    bell: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a6 6 0 0 0-6 6v3.6l-1.7 3.1A1 1 0 0 0 5.2 16h13.6a1 1 0 0 0 .9-1.3L18 11.6V8a6 6 0 0 0-6-6Zm0 20a3 3 0 0 0 2.8-2H9.2A3 3 0 0 0 12 22Z"/></svg>',
    flip: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3a9 9 0 0 1 8.7 6.7l1.3-1.3 1.4 1.4-3.7 3.7-3.7-3.7 1.4-1.4 1.1 1.1A7 7 0 0 0 5.3 9.3L3.4 8.7A9 9 0 0 1 12 3Zm-6.3 8.3 3.7 3.7L8 16.4l-1.1-1.1A7 7 0 0 0 18.7 14.7l1.9.6A9 9 0 0 1 3.3 14.3L2 15.6.6 14.2Z"/></svg>'
  };

  /* ---------------------------------------------------------------- 2 what a coin is
     Everything comes from the variant title, e.g.
       "Mewtwo (Oversized) (White & Purple)"  -> Mewtwo, oversized, classic, colour white & purple
       "Celebrations Logo Oversized (Gold glitter)" -> logo coin, oversized, gold + glitter
       "Fire energy (Oversized)" -> energy coin, Fire
     A new coin added in admin is understood the same way, with nothing to set. */

  /* the energy-type symbols, the same ones the card pages draw (assets/ll-card-data.js) */
  var EN = {
    Grass: { c: '#5aab5a', g: '#fff', d: 'M6 18C6 11 11 6.4 18 6c0 7-5 12-12 12z' },
    Fire: { c: '#e2622f', g: '#fff', d: 'M12 3.6c.6 3.1 4 4.3 4 7.6a4 4 0 0 1-8 0c0-1.4.7-2.5 1.5-3.1 0 1 .8 1.6 1.5 1.3 1-.5.2-2.6 1-6.8z' },
    Water: { c: '#3f8bd4', g: '#fff', d: 'M12 3.6c3.2 4.3 5 6.5 5 9.3a5 5 0 0 1-10 0c0-2.8 1.8-5 5-9.3z' },
    Lightning: { c: '#f5c518', g: '#6b4e00', d: 'M13.4 3 6 13.3h4.2L9 21l8-11.1h-4.6z' },
    Psychic: { c: '#a35fb5', g: '#fff', ev: 1, d: 'M12 7.4a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2zm0 2.7a1.9 1.9 0 1 1 0 3.8 1.9 1.9 0 0 1 0-3.8z' },
    Fighting: { c: '#c8702f', g: '#fff', d: 'M8.2 10.8h7.6v3.4a3.4 3.4 0 0 1-3.4 3.4h-.8a3.4 3.4 0 0 1-3.4-3.4zM8.2 12.2c-1.1 0-1.7-.6-1.7-1.4s.7-1.3 1.7-1.1z' },
    Darkness: { c: '#3f4a63', g: '#fff', d: 'M13.2 5a7 7 0 1 0 4 12.2A5.7 5.7 0 0 1 13.2 5z' },
    Metal: { c: '#8f9ea9', g: '#fff', d: 'M12 4.2l1.5 2.9 3.2-.7-.7 3.2 2.9 1.5-2.9 1.5.7 3.2-3.2-.7L12 19.8l-1.5-2.9-3.2.7.7-3.2L5.1 12.9l2.9-1.5-.7-3.2 3.2.7z' },
    Fairy: { c: '#e46fb0', g: '#fff', d: 'M12 3.8c.9 4.3 2.1 5.5 6.4 6.4-4.3.9-5.5 2.1-6.4 6.4-.9-4.3-2.1-5.5-6.4-6.4 4.3-.9 5.5-2.1 6.4-6.4z' },
    Dragon: { c: '#c9a227', g: '#fff', d: 'M12 4l6 4.6L12 20 6 8.6z' },
    Colorless: { c: '#d9d4c9', g: '#6f6759', d: 'M12 4.4l2.2 4.8 5.3.6-4 3.6 1.1 5.2L12 16.1l-4.7 2.9 1.1-5.2-4-3.6 5.3-.6z' }
  };
  var TYPE_ORDER = ['Grass', 'Fire', 'Water', 'Lightning', 'Psychic', 'Fighting', 'Darkness', 'Metal', 'Fairy', 'Dragon', 'Colorless'];
  function energyIco(type) {
    var e = EN[type] || EN.Colorless;
    return '<svg class="llcn-en" viewBox="0 0 24 24" role="img" aria-label="' + esc(type) + ' type"><title>' + esc(type) + ' type</title>' +
      '<circle cx="12" cy="12" r="11" fill="' + e.c + '" stroke-width="1"/>' +
      '<path d="' + e.d + '" fill="' + e.g + '"' + (e.ev ? ' fill-rule="evenodd"' : '') + '/></svg>';
  }

  /* The card type each Pokémon most often has in today's game, so a coin can be
     matched to a deck. Full names win over the species (Terastal Charizard ex
     is a Darkness card). A Pokémon not listed simply has no type filter. */
  var TYPE_OF = {
    'terastal charizard': 'Darkness',
    volcanion: 'Fire', mewtwo: 'Psychic', lycanroc: 'Fighting', lugia: 'Colorless', shaymin: 'Grass', mew: 'Psychic',
    suicune: 'Water', rayquaza: 'Dragon', manaphy: 'Water', pikachu: 'Lightning', yveltal: 'Darkness', xerneas: 'Fairy',
    dragapult: 'Psychic', crobat: 'Darkness', blastoise: 'Water', entei: 'Fire', charizard: 'Fire', empoleon: 'Water',
    eevee: 'Colorless', froakie: 'Water', venusaur: 'Grass', dragonite: 'Dragon', "sirfetch'd": 'Fighting', grookey: 'Grass',
    ninetales: 'Water', vulpix: 'Water', zoroark: 'Darkness', koraidon: 'Fighting', miraidon: 'Lightning', meowth: 'Colorless',
    snom: 'Water', delibird: 'Water', eiscue: 'Water', quaxly: 'Water', sprigatito: 'Grass', fuecoco: 'Fire', zeraora: 'Lightning',
    noivern: 'Dragon', zacian: 'Metal', zamazenta: 'Metal', arceus: 'Colorless', dialga: 'Metal', palkia: 'Water',
    lechonk: 'Colorless', melmetal: 'Metal', scorbunny: 'Fire', sobble: 'Water', chespin: 'Grass', fennekin: 'Fire',
    chikorita: 'Grass', cyndaquil: 'Fire', totodile: 'Water', greedent: 'Colorless', alcremie: 'Psychic', diancie: 'Fairy',
    lucario: 'Fighting', fidough: 'Psychic', darkrai: 'Darkness', gengar: 'Psychic', gardevoir: 'Psychic', umbreon: 'Darkness',
    espeon: 'Psychic', sylveon: 'Psychic', snorlax: 'Colorless', gyarados: 'Water', bulbasaur: 'Grass', squirtle: 'Water',
    charmander: 'Fire', greninja: 'Water', decidueye: 'Grass', incineroar: 'Fire', primarina: 'Water', giratina: 'Dragon',
    garchomp: 'Fighting', tyranitar: 'Darkness', metagross: 'Metal', groudon: 'Fighting', kyogre: 'Water', zekrom: 'Lightning',
    reshiram: 'Fire', kyurem: 'Water', necrozma: 'Psychic', solgaleo: 'Metal', lunala: 'Psychic', eternatus: 'Darkness',
    raichu: 'Lightning', jolteon: 'Lightning', flareon: 'Fire', vaporeon: 'Water', leafeon: 'Grass', glaceon: 'Water'
  };
  var ENERGY_WORD = {
    grass: 'Grass', fire: 'Fire', water: 'Water', lightning: 'Lightning', electric: 'Lightning', psychic: 'Psychic',
    fighting: 'Fighting', dark: 'Darkness', darkness: 'Darkness', metal: 'Metal', steel: 'Metal', fairy: 'Fairy',
    dragon: 'Dragon', normal: 'Colorless', colorless: 'Colorless', colourless: 'Colorless'
  };
  var TRAINERS = ['professor juniper', 'juniper', 'klara', 'cyrus', 'iono', 'larry', 'erika', 'cynthia', 'n', 'marnie', 'leon', 'nemona', 'arven', 'penny', 'lillie', 'misty', 'brock', 'ash', 'red', 'giovanni', 'lysandre', 'raihan', 'kieran', 'carmine', 'geeta', 'rika', 'hop', 'boss'];
  var EVENTS = [/celebrations? logo/, /pokemon day/, /\b\d+(st|nd|rd|th) celebration/, /\blogo\b/, /anniversary/];
  var DESCRIPTOR = /^(waving|side-facing|side facing|detective|gigantimax|gigantamax|terastal|tera|origin forme|mega|alolan|galarian|hisuian|paldean|shiny|radiant|ancient|future)\s+/;
  var SUBJECTS = [
    { k: 'all', t: 'All coins' },
    { k: 'pokemon', t: 'Pokémon' },
    { k: 'trainer', t: 'Trainers' },
    { k: 'energy', t: 'Energy' },
    { k: 'event', t: 'Logos & events' }
  ];
  var SUBJECT_WORD = { pokemon: 'Pokémon coin', trainer: 'Trainer coin', energy: 'Energy coin', event: 'Logo coin' };
  var FINISHES = ['Classic', 'Glitter', 'Cracked ice', 'Rainbow foil', 'Metal', 'Gold', 'Silver', 'Pixel art'];
  var FINISH_WORDS = {
    Classic: 'classic plain', Glitter: 'glitter sparkle sparkly', 'Cracked ice': 'cracked ice holo', 'Rainbow foil': 'rainbow foil holo shiny',
    Metal: 'metal metallic', Gold: 'gold golden', Silver: 'silver', 'Pixel art': 'pixel art 8-bit retro'
  };
  var PRICES = [
    { k: 'u1', t: 'Under £1', test: function (p) { return p < 100; } },
    { k: '1-3', t: '£1 to £3', test: function (p) { return p >= 100 && p <= 300; } },
    { k: 'o3', t: 'Over £3', test: function (p) { return p > 300; } }
  ];

  function understand(title) {
    var t = String(title || '');
    var tags = [], m, re = /\(([^)]*)\)/g;
    while ((m = re.exec(t))) tags.push(m[1].trim());
    var big = /\boversized\b/i.test(t) || /\bjumbo\b/i.test(t);
    var base = t.replace(/\([^)]*\)/g, ' ').replace(/\b(oversized|jumbo)\b/ig, ' ').replace(/\s+/g, ' ').trim();
    var finishes = [], colours = [], series = '';
    tags.forEach(function (g) {
      var k = g.toLowerCase(), hit = false;
      if (/^(oversized|jumbo)$/.test(k)) return;
      if (/vintage|wotc/.test(k)) { series = 'Vintage (WOTC era)'; return; }
      if (/glitter/.test(k)) { finishes.push('Glitter'); hit = true; }
      if (/cracked ice/.test(k)) { finishes.push('Cracked ice'); hit = true; }
      if (/rainbow|foil/.test(k)) { finishes.push('Rainbow foil'); hit = true; }
      if (/\bmetal\b/.test(k)) { finishes.push('Metal'); hit = true; }
      if (/\bgold\b/.test(k)) { finishes.push('Gold'); hit = true; }
      if (/\bsilver\b/.test(k)) { finishes.push('Silver'); hit = true; }
      if (/pixel/.test(k)) { finishes.push('Pixel art'); hit = true; }
      if (!hit) colours.push(cap(g));
    });
    if (!finishes.length) finishes.push('Classic');
    var n = norm(base);
    var subject = 'pokemon', type = '', species = '', display = base.replace(/Pokemon/g, 'Pokémon');
    if (/pokemon go/.test(n)) series = 'Pokémon GO';
    if (/^detective pikachu/.test(n)) series = 'Detective Pikachu';
    if (/celebrations? logo/.test(n)) series = 'Celebrations';
    if (/\b30th celebration/.test(n)) series = '30th Celebration';
    if (/pokemon day/.test(n)) series = 'Pokémon Day';
    var em = n.match(/^(\w+) energy$/);
    if (em && ENERGY_WORD[em[1]]) {
      subject = 'energy';
      type = ENERGY_WORD[em[1]];
      species = type.toLowerCase() + ' energy';
      display = (type === 'Colorless' ? 'Colorless' : type) + ' Energy';
    } else if (TRAINERS.indexOf(n) >= 0) {
      subject = 'trainer';
      species = n;
    } else if (EVENTS.some(function (r) { return r.test(n); })) {
      subject = 'event';
      species = n;
    } else {
      var sp = n.replace(/\bpokemon go\b/, '').trim();
      var guard = 0;
      while (DESCRIPTOR.test(sp) && guard++ < 4) sp = sp.replace(DESCRIPTOR, '');
      species = sp;
      type = TYPE_OF[n.replace(/\bpokemon go\b/, '').trim()] || TYPE_OF[sp] || '';
    }
    var words = [t, display, finishes.map(function (f) { return FINISH_WORDS[f]; }).join(' '), colours.join(' '),
      SUBJECT_WORD[subject], type, type && ('type ' + type), series, big ? 'oversized jumbo big large' : 'standard regular small', species];
    return {
      base: display, species: species, subject: subject, big: big, size: big ? 'big' : 'std',
      finishes: finishes, colours: colours, type: type, series: series,
      search: ' ' + norm(words.join(' ')) + ' '
    };
  }

  /* finish layers (styles: "finishes" in ll-coins.css). Stacked so glitter
     sits on top of a gold or metal sheen, as it does on the coin. */
  var FX = { Classic: 'gloss', Metal: 'metal', Gold: 'gold', Silver: 'silver', 'Pixel art': 'pixel', 'Rainbow foil': 'rainbow', 'Cracked ice': 'ice', Glitter: 'glitter' };
  var FX_ORDER = ['gloss', 'metal', 'gold', 'silver', 'pixel', 'rainbow', 'ice', 'glitter'];
  function addFx(coinEl, finishes) {
    if (!coinEl || coinEl.classList.contains('llcn-coin--blank') || coinEl.querySelector('.llcn-fx')) return;
    finishes.map(function (f) { return FX[f]; }).filter(Boolean)
      .sort(function (a, b) { return FX_ORDER.indexOf(a) - FX_ORDER.indexOf(b); })
      .forEach(function (k) {
        var i = document.createElement('i');
        i.className = 'llcn-fx llcn-fx--' + k;
        i.setAttribute('aria-hidden', 'true');
        coinEl.appendChild(i);
      });
  }

  /* read the coins back from the grid */
  var coins = $$('.llcn-tile', grid).map(function (el) {
    var c = understand(el.getAttribute('data-t'));
    c.el = el;
    c.id = Number(el.getAttribute('data-v'));
    c.i = Number(el.getAttribute('data-i'));
    c.t = el.getAttribute('data-t');
    c.p = Number(el.getAttribute('data-p')) || 0;
    c.c = Number(el.getAttribute('data-c')) || 0;
    c.a = el.getAttribute('data-a') === 'true';
    var mx = Number(el.getAttribute('data-m'));
    c.max = c.a ? (mx > 0 ? Math.min(mx, 20) : 20) : 0;
    c.stock = mx;
    c.coin = el.querySelector('.llcn-coin');
    addFx(c.coin, c.finishes);
    c.link = el.querySelector('[data-view]');
    c.act = el.querySelector('[data-act]');
    c.badge = el.querySelector('[data-qty]');
    var slot = el.querySelector('[data-type-slot]');
    if (slot && c.type) slot.innerHTML = energyIco(c.type);
    return c;
  });
  var byId = {};
  coins.forEach(function (c) { byId[c.id] = c; });
  if (!coins.length) return;

  /* a copy of a coin at another size; the photo is re-requested big enough
     for where it is going (the grid's srcset tops out for tiles) */
  function coinClone(c, px) {
    var node = c.coin.cloneNode(true);
    var img = node.querySelector('img');
    if (img) {
      var base = img.getAttribute('data-base');
      /* read from the inline style Liquid wrote: getComputedStyle here would
         force a style pass over the whole page for every copy */
      var s = parseFloat(c.coin.style.getPropertyValue('--s')) || 1.06;
      var want = Math.ceil((px || 120) * s * Math.min(window.devicePixelRatio || 1, 2.5));
      var steps = [120, 240, 360, 480, 600, 720, 840, 960, 1200, 1440];
      var w = steps[steps.length - 1];
      for (var i = 0; i < steps.length; i++) { if (steps[i] >= want) { w = steps[i]; break; } }
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.removeAttribute('fetchpriority');
      img.setAttribute('loading', 'eager');
      if (base) img.src = base + (base.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
      img.alt = '';
    }
    node.removeAttribute('data-framed');
    node.style.removeProperty('--lx');
    node.style.removeProperty('--ly');
    return node;
  }

  /* ---------------------------------------------------------------- light
     Where the light falls on each coin (--lx, --ly). The pointer leads on a
     coin it is over; otherwise the light sweeps with scroll, from high left
     as a coin enters the screen to lower right as it leaves, so the finishes
     move while you browse and sit still when you stop. Work happens only in
     a frame where something moved, and only for coins on screen. */
  var Light = (function () {
    function set(el, x, y) {
      if (!el) return;
      el.style.setProperty('--lx', Math.max(0, Math.min(1, x)).toFixed(3));
      el.style.setProperty('--ly', Math.max(0, Math.min(1, y)).toFixed(3));
    }
    var onScreen = new Set(), held = null, raf = 0, n = 0;
    function frame() {
      raf = 0;
      var H = innerHeight || 800, list = [], rects = [];
      onScreen.forEach(function (el) { if (el !== held) list.push(el); });
      list.forEach(function (el) { rects.push(el.getBoundingClientRect()); });   /* read everything, then write */
      list.forEach(function (el, i) {
        var r = rects[i], tt = (r.top + r.height / 2) / H;
        var jitter = ((el._llIdx || 0) % 5 - 2) * .05;
        set(el, .16 + .66 * tt + jitter, .1 + .46 * tt);
      });
    }
    function kick() { if (!raf) raf = requestAnimationFrame(frame); }
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (ents) {
      ents.forEach(function (e) { if (e.isIntersecting) onScreen.add(e.target); else onScreen.delete(e.target); });
      kick();
    }, { rootMargin: '60px 0px' }) : null;
    function track(el, i) {
      if (reduce || !io || !el || !el.querySelector('.llcn-fx:not(.llcn-fx--gloss)')) return;
      el._llIdx = i == null ? n : i;
      n++;
      io.observe(el);
    }
    if (!reduce) window.addEventListener('scroll', kick, { passive: true });
    /* the pointer, on desktop: over a tile's coin or a heading coin */
    if (fine && !reduce) {
      root.addEventListener('pointermove', function (e) {
        var host = e.target.closest && e.target.closest('.llcn-tile__coin, .llcn-hcoin');
        var coin = host && host.querySelector('.llcn-coin');
        if (!coin || e.pointerType !== 'mouse') return;
        if (held !== coin) { coin.classList.add('is-ease'); clearTimeout(coin._llEase); coin._llEase = setTimeout(function () { coin.classList.remove('is-ease'); }, 260); }
        held = coin;
        var r = coin.getBoundingClientRect();
        set(coin, (e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height);
      }, { passive: true });
      root.addEventListener('pointerout', function (e) {
        var host = e.target.closest && e.target.closest('.llcn-tile__coin, .llcn-hcoin');
        if (!host || (e.relatedTarget && host.contains(e.relatedTarget))) return;
        var coin = host.querySelector('.llcn-coin');
        held = null;
        if (coin) {
          coin.classList.add('is-ease');
          clearTimeout(coin._llEase);
          coin._llEase = setTimeout(function () { coin.classList.remove('is-ease'); }, 500);
          if (!coin._llIdx && coin._llIdx !== 0) { coin.style.removeProperty('--lx'); coin.style.removeProperty('--ly'); }
        }
        kick();
      });
    }
    return { set: set, track: track, kick: kick };
  })();
  coins.forEach(function (c, i) { Light.track(c.coin, i); });

  /* ---------------------------------------------------------------- 3 filters */
  var S = { q: '', show: 'all', name: '', size: [], finish: [], type: [], price: '', stock: false, sort: 'featured' };
  var DEFAULTS = JSON.stringify(S);

  (function readUrl() {
    try {
      var u = new URL(location.href), g = u.searchParams;
      S.q = (g.get('q') || '').slice(0, 60);
      if (SUBJECTS.some(function (x) { return x.k === g.get('show'); })) S.show = g.get('show');
      S.name = (g.get('name') || '').toLowerCase();
      S.size = (g.get('size') || '').split(',').filter(function (v) { return v === 'big' || v === 'std'; });
      S.finish = (g.get('finish') || '').split(',').filter(function (v) { return FINISHES.indexOf(v) >= 0; });
      S.type = (g.get('type') || '').split(',').filter(function (v) { return EN[v]; });
      if (PRICES.some(function (x) { return x.k === g.get('price'); })) S.price = g.get('price');
      S.stock = g.get('stock') === '1';
      if (['featured', 'new', 'low', 'high', 'az'].indexOf(g.get('sort')) >= 0) S.sort = g.get('sort');
    } catch (e) {}
  })();
  function writeUrl() {
    try {
      var u = new URL(location.href), g = u.searchParams;
      function set(k, v) { if (v) g.set(k, v); else g.delete(k); }
      set('q', S.q);
      set('show', S.show === 'all' ? '' : S.show);
      set('name', S.name);
      set('size', S.size.join(','));
      set('finish', S.finish.join(','));
      set('type', S.type.join(','));
      set('price', S.price);
      set('stock', S.stock ? '1' : '');
      set('sort', S.sort === 'featured' ? '' : S.sort);
      history.replaceState(history.state, '', u.pathname + (g.toString() ? '?' + g.toString() : '') + u.hash);
    } catch (e) {}
  }

  function qWords() { return norm(S.q).split(' ').filter(Boolean); }
  function passes(c, skip, words) {
    if (skip !== 'q' && words.length) {
      for (var i = 0; i < words.length; i++) if (c.search.indexOf(words[i]) < 0) return false;
    }
    if (skip !== 'show' && S.show !== 'all' && c.subject !== S.show) return false;
    if (skip !== 'name' && S.name && c.species !== S.name) return false;
    if (skip !== 'size' && S.size.length && S.size.indexOf(c.size) < 0) return false;
    if (skip !== 'finish' && S.finish.length && !c.finishes.some(function (f) { return S.finish.indexOf(f) >= 0; })) return false;
    if (skip !== 'type' && S.type.length && S.type.indexOf(c.type) < 0) return false;
    if (skip !== 'price' && S.price) {
      var pr = PRICES.filter(function (x) { return x.k === S.price; })[0];
      if (pr && !pr.test(c.p)) return false;
    }
    if (skip !== 'stock' && S.stock && !c.a) return false;
    return true;
  }
  function counts(facet, key) {
    var words = qWords(), out = {};
    coins.forEach(function (c) {
      if (!passes(c, facet, words)) return;
      var v = key(c);
      (Array.isArray(v) ? v : [v]).forEach(function (x) { if (x !== '' && x != null) out[x] = (out[x] || 0) + 1; });
    });
    return out;
  }
  function sorter() {
    var s = S.sort;
    return function (a, b) {
      if (a.a !== b.a) return a.a ? -1 : 1;          // sold out always last
      if (s === 'low' && a.p !== b.p) return a.p - b.p;
      if (s === 'high' && a.p !== b.p) return b.p - a.p;
      if (s === 'az') { var x = a.base.localeCompare(b.base); if (x) return x; }
      if (s === 'new' && a.id !== b.id) return b.id - a.id;
      return a.i - b.i;
    };
  }

  /* the controls */
  var elShow = $('[data-show]'), elPop = $('[data-popular]'), elFilters = $('[data-filters]');
  var elCount = $('[data-count]'), elActive = $('[data-active]'), elEmpty = $('[data-empty]');
  var elQ = $('[data-q]'), elQx = $('[data-q-clear]'), elSort = $('[data-sort]'), elFcount = $('[data-fcount]');
  var elSide = $('[data-side]'), elShowN = $('[data-show-n]');

  /* representative coin for a finish swatch: the first in-stock coin with it */
  function swatchFor(f) {
    var c = coins.filter(function (x) { return x.a && x.finishes.indexOf(f) >= 0 && x.coin.querySelector('img'); })[0] ||
            coins.filter(function (x) { return x.finishes.indexOf(f) >= 0 && x.coin.querySelector('img'); })[0];
    return c ? coinClone(c, 22).outerHTML.replace('class="llcn-coin', 'class="llcn-opt__sw llcn-coin') : '<i class="llcn-opt__sw"></i>';
  }
  var SW = {};
  FINISHES.forEach(function (f) { if (coins.some(function (c) { return c.finishes.indexOf(f) >= 0; })) SW[f] = swatchFor(f); });

  /* popular names: any Pokémon with two or more designs */
  var POP = (function () {
    var m = {};
    coins.forEach(function (c) { if (c.subject === 'pokemon' && c.species) m[c.species] = (m[c.species] || 0) + 1; });
    return Object.keys(m).filter(function (k) { return m[k] >= 2; }).sort(function (a, b) { return m[b] - m[a] || a.localeCompare(b); }).slice(0, 10).map(function (k) {
      var face = coins.filter(function (c) { return c.species === k && c.a && c.coin.querySelector('img'); })[0] || coins.filter(function (c) { return c.species === k; })[0];
      return { k: k, t: k.split(' ').map(cap).join(' '), face: face };
    });
  })();

  function buildControls() {
    var html;
    if (elShow) {
      html = SUBJECTS.filter(function (s) { return s.k === 'all' || coins.some(function (c) { return c.subject === s.k; }); }).map(function (s) {
        return '<button type="button" class="llcn-seg" data-f="show" data-v="' + s.k + '" aria-pressed="false">' + esc(s.t) + ' <small></small></button>';
      }).join('');
      elShow.innerHTML = html;
    }
    if (elPop && POP.length) {
      elPop.hidden = false;
      elPop.innerHTML = '<span>Popular</span>' + POP.map(function (p) {
        return '<button type="button" class="llcn-pop" data-f="name" data-v="' + esc(p.k) + '" aria-pressed="false">' +
          (p.face ? coinClone(p.face, 24).outerHTML : '') + esc(p.t) + ' <small></small></button>';
      }).join('');
    }
    if (!elFilters) return;
    var tick = '<span class="llcn-opt__box">' + ICON.tick + '</span>';
    var g = [];
    g.push('<div class="llcn-fg"><label class="llcn-switch"><span>In stock only</span><input type="checkbox" data-f="stock"><i></i></label></div>');
    if (coins.some(function (c) { return c.big; }) && coins.some(function (c) { return !c.big; })) {
      g.push('<div class="llcn-fg"><h3 class="llcn-fg__h">Size</h3><div class="llcn-sizes">' +
        '<button type="button" class="llcn-size" data-f="size" data-v="std" data-size="std" aria-pressed="false"><i></i>Standard<small></small></button>' +
        '<button type="button" class="llcn-size" data-f="size" data-v="big" data-size="big" aria-pressed="false"><i></i>Oversized<small></small></button>' +
        '</div></div>');
    }
    g.push('<div class="llcn-fg"><h3 class="llcn-fg__h">Finish</h3>' + FINISHES.filter(function (f) { return SW[f]; }).map(function (f) {
      return '<label class="llcn-opt" data-opt="finish:' + esc(f) + '"><input type="checkbox" data-f="finish" value="' + esc(f) + '">' + tick + SW[f] + '<span>' + esc(f) + '</span><small></small></label>';
    }).join('') + '</div>');
    var types = TYPE_ORDER.filter(function (t) { return coins.some(function (c) { return c.type === t; }); });
    if (types.length) {
      g.push('<div class="llcn-fg"><h3 class="llcn-fg__h">Energy type</h3><p class="llcn-fg__sub">Match a coin to your deck.</p><div class="llcn-types">' + types.map(function (t) {
        return '<button type="button" class="llcn-type" data-f="type" data-v="' + t + '" aria-pressed="false">' + energyIco(t) + '<span>' + (t === 'Colorless' ? 'Colourless' : t) + '</span><small></small></button>';
      }).join('') + '</div></div>');
    }
    g.push('<div class="llcn-fg"><h3 class="llcn-fg__h">Price</h3><div class="llcn-prices">' + PRICES.map(function (p) {
      return '<button type="button" class="llcn-price" data-f="price" data-v="' + p.k + '" aria-pressed="false">' + esc(p.t) + ' <small></small></button>';
    }).join('') + '</div></div>');
    elFilters.innerHTML = g.join('');
  }

  function toggleIn(arr, v) { var i = arr.indexOf(v); if (i >= 0) arr.splice(i, 1); else arr.push(v); }
  function onFilter(e) {
    var b = e.target.closest('[data-f]');
    if (!b || !root.contains(b)) return;
    var f = b.getAttribute('data-f'), v = b.getAttribute('data-v') || b.value;
    if (b.tagName === 'INPUT' && e.type === 'click') return;   // inputs report through change
    if (f === 'show') S.show = v;
    else if (f === 'name') S.name = S.name === v ? '' : v;
    else if (f === 'size') toggleIn(S.size, v);
    else if (f === 'finish') toggleIn(S.finish, v);
    else if (f === 'type') toggleIn(S.type, v);
    else if (f === 'price') S.price = S.price === v ? '' : v;
    else if (f === 'stock') S.stock = !!b.checked;
    apply({ scroll: true });
  }
  root.addEventListener('click', onFilter);
  root.addEventListener('change', function (e) { if (e.target.matches('input[data-f]')) onFilter(e); });

  var qTimer = null;
  if (elQ) {
    elQ.value = S.q;
    elQ.addEventListener('input', function () {
      clearTimeout(qTimer);
      qTimer = setTimeout(function () { S.q = elQ.value.trim(); apply(); }, 120);
    });
    elQ.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && elQ.value) { elQ.value = ''; S.q = ''; apply(); }
      if (e.key === 'Enter') { e.preventDefault(); elQ.blur(); }
    });
  }
  if (elQx) elQx.addEventListener('click', function () { elQ.value = ''; S.q = ''; apply(); elQ.focus(); });
  if (elSort) {
    elSort.value = S.sort;
    elSort.addEventListener('change', function () { S.sort = elSort.value; apply({ scroll: true }); });
  }
  $$('[data-clear]').forEach(function (b) {
    b.addEventListener('click', function () {
      var sort = S.sort;
      S = JSON.parse(DEFAULTS);
      S.sort = sort;
      if (elQ) elQ.value = '';
      apply({ scroll: true });
    });
  });

  function activeList() {
    var a = [];
    if (S.q) a.push({ t: '"' + S.q + '"', off: function () { S.q = ''; if (elQ) elQ.value = ''; } });
    if (S.show !== 'all') a.push({ t: SUBJECTS.filter(function (x) { return x.k === S.show; })[0].t, off: function () { S.show = 'all'; } });
    if (S.name) a.push({ t: S.name.split(' ').map(cap).join(' '), off: function () { S.name = ''; } });
    S.size.forEach(function (v) { a.push({ t: v === 'big' ? 'Oversized' : 'Standard', off: function () { toggleIn(S.size, v); } }); });
    S.finish.forEach(function (v) { a.push({ t: v, off: function () { toggleIn(S.finish, v); } }); });
    S.type.forEach(function (v) { a.push({ t: (v === 'Colorless' ? 'Colourless' : v) + ' type', off: function () { toggleIn(S.type, v); } }); });
    if (S.price) a.push({ t: PRICES.filter(function (x) { return x.k === S.price; })[0].t, off: function () { S.price = ''; } });
    if (S.stock) a.push({ t: 'In stock', off: function () { S.stock = false; } });
    return a;
  }

  var shown = [];
  var lastOrder = '';
  function apply(opts) {
    opts = opts || {};
    var words = qWords();
    shown = coins.filter(function (c) { return passes(c, null, words); }).sort(sorter());
    var on = {};
    shown.forEach(function (c) { on[c.id] = 1; });
    coins.forEach(function (c) { c.el.hidden = !on[c.id]; });
    var order = coins.slice().sort(function (a, b) {
      var sa = on[a.id] ? 0 : 1, sb = on[b.id] ? 0 : 1;
      return sa - sb || sorter()(a, b);
    });
    var key = order.map(function (c) { return c.id; }).join(',');
    if (key !== lastOrder) {
      var frag = document.createDocumentFragment();
      order.forEach(function (c) { frag.appendChild(c.el); });
      grid.appendChild(frag);
      lastOrder = key;
    }

    /* counts beside every option, as they would be with that option ticked */
    var cShow = counts('show', function (c) { return c.subject; });
    var total = 0; Object.keys(cShow).forEach(function (k) { total += cShow[k]; });
    $$('[data-f="show"]').forEach(function (b) {
      var v = b.getAttribute('data-v'), n = v === 'all' ? total : (cShow[v] || 0);
      b.setAttribute('aria-pressed', S.show === v ? 'true' : 'false');
      b.querySelector('small').textContent = n;
      b.disabled = !n && S.show !== v;
    });
    /* popular names: a chip that would show nothing steps aside, and the row
       goes when none apply (Energy, Trainers, a finish no Pokémon has) */
    var cName = counts('name', function (c) { return c.species; });
    var anyName = false;
    $$('[data-f="name"]').forEach(function (b) {
      var v = b.getAttribute('data-v'), n = cName[v] || 0;
      b.setAttribute('aria-pressed', S.name === v ? 'true' : 'false');
      b.querySelector('small').textContent = n;
      b.hidden = !n && S.name !== v;
      if (!b.hidden) anyName = true;
    });
    if (elPop && POP.length) elPop.hidden = !anyName;
    var cSize = counts('size', function (c) { return c.size; });
    $$('[data-f="size"]').forEach(function (b) {
      var v = b.getAttribute('data-v');
      b.setAttribute('aria-pressed', S.size.indexOf(v) >= 0 ? 'true' : 'false');
      b.querySelector('small').textContent = (cSize[v] || 0) + ' coins';
    });
    var cFin = counts('finish', function (c) { return c.finishes; });
    $$('input[data-f="finish"]').forEach(function (i) {
      i.checked = S.finish.indexOf(i.value) >= 0;
      var n = cFin[i.value] || 0, row = i.closest('.llcn-opt');
      row.querySelector('small').textContent = n;
      row.classList.toggle('is-zero', !n && !i.checked);
    });
    var cType = counts('type', function (c) { return c.type; });
    $$('[data-f="type"]').forEach(function (b) {
      var v = b.getAttribute('data-v'), n = cType[v] || 0;
      b.setAttribute('aria-pressed', S.type.indexOf(v) >= 0 ? 'true' : 'false');
      b.querySelector('small').textContent = n;
      b.classList.toggle('is-zero', !n && S.type.indexOf(v) < 0);
    });
    var cPrice = counts('price', function (c) { return PRICES.filter(function (x) { return x.test(c.p); }).map(function (x) { return x.k; }); });
    $$('[data-f="price"]').forEach(function (b) {
      var v = b.getAttribute('data-v');
      b.setAttribute('aria-pressed', S.price === v ? 'true' : 'false');
      b.querySelector('small').textContent = cPrice[v] || 0;
    });
    var st = $('input[data-f="stock"]');
    if (st) st.checked = S.stock;

    var act = activeList();
    if (elActive) {
      elActive.innerHTML = act.map(function (a, i) {
        return '<button type="button" class="llcn-chipx" data-off="' + i + '">' + esc(a.t) + ICON.x + '</button>';
      }).join('') + (act.length > 1 ? '<button type="button" class="llcn-link" data-off="all">Clear all</button>' : '');
      elActive._list = act;
    }
    if (elCount) {
      elCount.innerHTML = shown.length === coins.length
        ? '<b>' + coins.length + '</b> coins'
        : '<b>' + shown.length + '</b> of ' + coins.length + ' coins';
    }
    var nf = act.filter(function (a) { return a.t.charAt(0) !== '"'; }).length;
    if (elFcount) { elFcount.hidden = !nf; elFcount.textContent = nf; }
    if (elShowN) elShowN.textContent = shown.length ? 'Show ' + shown.length + ' coin' + (shown.length === 1 ? '' : 's') : 'No coins match';
    if (elEmpty) elEmpty.hidden = shown.length > 0;
    if (elQx) elQx.hidden = !(elQ && elQ.value);
    writeUrl();

    if (opts.scroll && !elSide.classList.contains('is-open')) {
      var top = grid.getBoundingClientRect().top;
      if (top < 0) {
        var shop = $('[data-shop]');
        shop.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }
    }
  }
  if (elActive) {
    elActive.addEventListener('click', function (e) {
      var b = e.target.closest('[data-off]');
      if (!b) return;
      var k = b.getAttribute('data-off');
      if (k === 'all') { var sort = S.sort; S = JSON.parse(DEFAULTS); S.sort = sort; if (elQ) elQ.value = ''; }
      else if (elActive._list[k]) elActive._list[k].off();
      apply({ scroll: true });
    });
  }

  /* the filter sheet on tablets and phones */
  var scrim = document.createElement('div');
  scrim.className = 'llcn-scrim';
  document.body.appendChild(scrim);
  var sheetFrom = null;
  function sheetOpen() {
    sheetFrom = document.activeElement;
    elSide.classList.add('is-open');
    scrim.classList.add('is-on');
    document.documentElement.classList.add('llcn-lock');
    $$('[data-open-filters]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () { elSide.focus({ preventScroll: true }); }, 30);
  }
  function sheetClose() {
    if (!elSide.classList.contains('is-open')) return;
    elSide.classList.remove('is-open');
    scrim.classList.remove('is-on');
    document.documentElement.classList.remove('llcn-lock');
    $$('[data-open-filters]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (sheetFrom && sheetFrom.focus) sheetFrom.focus({ preventScroll: true });
    var top = grid.getBoundingClientRect().top;
    if (top < 0 || top > innerHeight) $('[data-shop]').scrollIntoView({ behavior: 'auto', block: 'start' });
  }
  $$('[data-open-filters]').forEach(function (b) { b.addEventListener('click', sheetOpen); });
  $$('[data-close-filters]').forEach(function (b) { b.addEventListener('click', sheetClose); });
  scrim.addEventListener('click', function () { sheetClose(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') sheetClose(); });

  $$('[data-jump]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      $('[data-shop]').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  });

  /* ---------------------------------------------------------------- 4 picks
     { variant id: quantity }, kept in localStorage for the visit (a week), so
     a reload or a look at another page does not lose them. */
  var PKEY = 'll_coin_picks';
  var picks = (function () {
    try {
      var o = JSON.parse(localStorage.getItem(PKEY) || 'null');
      if (o && o.t && Date.now() - o.t < 7 * 864e5 && o.v) {
        var out = {}, order = [];
        (o.o || Object.keys(o.v)).forEach(function (id) {
          var c = byId[id], n = Number(o.v[id]);
          if (c && c.a && n > 0) { out[id] = Math.min(n, c.max); order.push(String(id)); }
        });
        return { v: out, o: order };
      }
    } catch (e) {}
    return { v: {}, o: [] };
  })();
  function savePicks() {
    try { localStorage.setItem(PKEY, JSON.stringify({ t: Date.now(), v: picks.v, o: picks.o })); } catch (e) {}
  }
  function qtyOf(id) { return picks.v[id] || 0; }
  function setQty(id, n, opts) {
    opts = opts || {};
    var c = byId[id];
    if (!c) return;
    n = Math.max(0, Math.min(c.max, n));
    var was = qtyOf(id);
    id = String(id);
    if (n) {
      picks.v[id] = n;
      if (picks.o.indexOf(id) < 0) picks.o.push(id);
    } else {
      delete picks.v[id];
      picks.o = picks.o.filter(function (x) { return x !== id; });
    }
    savePicks();
    paintTile(c, n > was);
    if (!opts.quiet) tray.render(n > was && !was ? c.id : null);
    if (view.cur && view.cur.id === c.id) view.paintPick();
  }
  function paintTile(c, bump) {
    var n = qtyOf(c.id);
    c.el.classList.toggle('is-picked', n > 0);
    if (c.badge) {
      c.badge.hidden = !n;
      c.badge.textContent = '×' + n;
      if (bump && !reduce) { c.badge.classList.remove('is-bump'); void c.badge.offsetWidth; c.badge.classList.add('is-bump'); }
    }
    if (!c.a || !c.act) return;
    if (!n) {
      if (!c.act.querySelector('[data-pick]')) {
        c.act.innerHTML = '<button type="button" class="llcn-pick" data-pick aria-label="Pick ' + esc(c.t) + '">' + ICON.plus + '<span>Pick</span></button>';
      }
    } else {
      var step = c.act.querySelector('.llcn-step');
      if (!step) {
        c.act.innerHTML = '<div class="llcn-step" role="group" aria-label="How many ' + esc(c.t) + '">' +
          '<button type="button" data-less aria-label="One fewer">' + ICON.minus + '</button>' +
          '<output aria-live="polite"></output>' +
          '<button type="button" data-more aria-label="One more">' + ICON.plus + '</button></div>';
        step = c.act.querySelector('.llcn-step');
      }
      step.querySelector('output').textContent = n + ' picked';
      step.querySelector('[data-more]').disabled = n >= c.max;
    }
  }
  grid.addEventListener('click', function (e) {
    var tile = e.target.closest('.llcn-tile');
    if (!tile) return;
    var c = byId[tile.getAttribute('data-v')];
    if (!c) return;
    if (e.target.closest('[data-pick]')) {
      e.preventDefault();
      fly(c.coin, c);
      setQty(c.id, 1);
      /* keyboard users keep their place on the new stepper */
      if (e.detail === 0) { var more = c.act.querySelector('[data-more]'); if (more) more.focus({ preventScroll: true }); }
    } else if (e.target.closest('[data-more]')) {
      setQty(c.id, qtyOf(c.id) + 1);
    } else if (e.target.closest('[data-less]')) {
      var n = qtyOf(c.id) - 1;
      setQty(c.id, n);
      if (!n && e.detail === 0) { var p = c.act.querySelector('[data-pick]'); if (p) p.focus({ preventScroll: true }); }
    } else if (e.target.closest('[data-view]')) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      e.preventDefault();
      view.open(c.id);
    }
  });

  /* ---------------------------------------------------------------- 5 the picks tray */
  var tray = (function () {
    var el = document.createElement('div');
    el.className = 'llcn-tray';
    el.setAttribute('role', 'region');
    el.setAttribute('aria-label', 'Your picked coins');
    el.innerHTML =
      '<div class="llcn-tray__panel" id="llcn-tray-panel">' +
        '<div class="llcn-tray__ph"><h2>Your picks</h2><button type="button" class="llcn-link" data-tray-clear>Clear all</button></div>' +
        '<ul class="llcn-tray__list" data-tray-list></ul>' +
      '</div>' +
      '<div class="llcn-tray__bar">' +
        '<div class="llcn-tray__stack" data-tray-stack aria-hidden="true"></div>' +
        '<div class="llcn-tray__sum" data-tray-toggle><b data-tray-title></b><span data-tray-meta></span></div>' +
        '<button type="button" class="llcn-tray__review" data-tray-toggle aria-expanded="false" aria-controls="llcn-tray-panel">Review' + ICON.up + '</button>' +
        '<button type="button" class="llcn-btn llcn-tray__add" data-tray-add><span data-tray-add-t>Add to basket</span>' + ICON.arrow + '</button>' +
      '</div>';
    document.body.appendChild(el);
    var stack = el.querySelector('[data-tray-stack]'), list = el.querySelector('[data-tray-list]');
    var title = el.querySelector('[data-tray-title]'), meta = el.querySelector('[data-tray-meta]');
    var addBtn = el.querySelector('[data-tray-add]'), addT = el.querySelector('[data-tray-add-t]');
    var review = el.querySelector('.llcn-tray__review');
    var stackIds = [];

    function totals() {
      var n = 0, sum = 0;
      picks.o.forEach(function (id) { var c = byId[id], q = picks.v[id]; if (c && q) { n += q; sum += q * c.p; } });
      return { designs: picks.o.length, n: n, sum: sum };
    }
    function publish() {
      var h = el.classList.contains('is-on') ? el.querySelector('.llcn-tray__bar').offsetHeight + (innerWidth < 768 ? 10 : 20) : 0;
      document.documentElement.style.setProperty('--ll-pdpbar-h', h + 'px');
    }
    function setOpen(on) {
      el.classList.toggle('is-open', on);
      review.setAttribute('aria-expanded', on ? 'true' : 'false');
      /* The panel fills the bottom right corner, where the watchlist nudge
         (z 990) and Empire's back to top button (z 1200) live, and the tray
         is at z 70. Rather than climb over them, they stand down while the
         panel is open. ll-coins.css has the rule. */
      document.documentElement.classList.toggle('ll-busy', !!on);
    }
    function render(newId) {
      var t = totals();
      var on = t.designs > 0;
      el.classList.toggle('is-on', on);
      if (!on) setOpen(false);
      title.textContent = t.designs + ' design' + (t.designs === 1 ? '' : 's') + ' picked';
      meta.textContent = t.n + ' coin' + (t.n === 1 ? '' : 's') + ' · ' + formatMoney(t.sum);
      addT.textContent = innerWidth < 400 ? 'Add ' + t.n : 'Add ' + t.n + ' to basket';
      addBtn.setAttribute('aria-label', 'Add ' + t.n + ' coin' + (t.n === 1 ? '' : 's') + ' to your basket, ' + formatMoney(t.sum));

      /* the stack: the last four picked, newest on top */
      var want = picks.o.slice(-4);
      if (want.join() !== stackIds.join()) {
        stack.innerHTML = '';
        want.forEach(function (id) {
          var n = coinClone(byId[id], 38);
          if (String(id) === String(newId) && !reduce) n.classList.add('is-new');
          stack.appendChild(n);
        });
        stackIds = want;
      }

      list.innerHTML = picks.o.map(function (id) {
        var c = byId[id], q = picks.v[id];
        return '<li class="llcn-line" data-line="' + id + '">' + coinClone(c, 46).outerHTML +
          '<div class="llcn-line__t"><b>' + esc(c.base) + '</b><span>' + esc([c.big ? 'Oversized' : 'Standard'].concat(c.finishes.filter(function (f) { return f !== 'Classic'; })).concat(c.colours).join(' · ')) + ' · ' + esc(formatMoney(c.p)) + ' each</span></div>' +
          '<div class="llcn-step" role="group" aria-label="How many ' + esc(c.t) + '"><button type="button" data-line-less aria-label="One fewer">' + ICON.minus + '</button><output>' + q + '</output><button type="button" data-line-more aria-label="One more"' + (q >= c.max ? ' disabled' : '') + '>' + ICON.plus + '</button></div>' +
          '<span class="llcn-line__p">' + esc(formatMoney(c.p * q)) + '</span>' +
          '<button type="button" class="llcn-line__x" data-line-x aria-label="Remove ' + esc(c.t) + '">' + ICON.bin + '</button></li>';
      }).join('');
      publish();
    }
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-tray-toggle]')) { setOpen(!el.classList.contains('is-open')); return; }
      if (e.target.closest('[data-tray-add]')) { addAll(); return; }
      if (e.target.closest('[data-tray-clear]')) {
        picks.o.slice().forEach(function (id) { setQty(id, 0, { quiet: true }); });
        render();
        return;
      }
      var line = e.target.closest('[data-line]');
      if (!line) return;
      var id = line.getAttribute('data-line');
      if (e.target.closest('[data-line-more]')) setQty(id, qtyOf(id) + 1);
      else if (e.target.closest('[data-line-less]')) setQty(id, qtyOf(id) - 1);
      else if (e.target.closest('[data-line-x]')) setQty(id, 0);
      else if (e.target.closest('.llcn-coin, .llcn-line__t')) { setOpen(false); view.open(Number(id)); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.classList.contains('is-open')) setOpen(false); });
    document.addEventListener('click', function (e) { if (el.classList.contains('is-open') && !el.contains(e.target)) setOpen(false); });
    window.addEventListener('resize', publish, { passive: true });

    function busy(on) {
      addBtn.classList.toggle('is-loading', on);
      addBtn.disabled = on;
      if (on) addBtn.setAttribute('aria-busy', 'true'); else addBtn.removeAttribute('aria-busy');
    }
    function addAll() {
      var items = picks.o.map(function (id) { return { id: Number(id), quantity: picks.v[id] }; }).filter(function (i) { return i.quantity > 0; });
      if (!items.length) return;
      var t = totals();
      var faces = picks.o.slice(0, 3).map(function (id) { return byId[id]; });
      human(function () {
        busy(true);
        Cart.add(items).then(function (res) {
          if (!res.ok) { toast.msg(failText(res), { tone: 'warn' }); return; }
          return Cart.refresh().then(function (cart) {
            var names = picks.o.map(function (id) { return byId[id].base + (picks.v[id] > 1 ? ' ×' + picks.v[id] : ''); });
            toast.cart({
              title: t.n + ' coin' + (t.n === 1 ? '' : 's') + ' added',
              faces: faces,
              meta: names.slice(0, 3).join(', ') + (names.length > 3 ? ' and ' + (names.length - 3) + ' more' : ''),
              price: t.sum
            }, cart);
            picks.o.slice().forEach(function (id) { setQty(id, 0, { quiet: true }); });
            render();
          });
        }).catch(function () {
          toast.msg('We could not reach the basket. Check your connection and try again.', { tone: 'warn' });
        }).then(function () { busy(false); });
      });
    }
    return { el: el, render: render, stack: stack, publish: publish };
  })();

  /* a picked coin is tossed into the tray */
  function fly(fromCoin, c) {
    if (reduce || !fromCoin || !fromCoin.getBoundingClientRect) return;
    var wasOn = tray.el.classList.contains('is-on');
    var r0 = fromCoin.getBoundingClientRect();
    if (!r0.width) return;
    requestAnimationFrame(function () {
      var slot = tray.stack.lastElementChild || tray.stack;
      var r1 = slot.getBoundingClientRect();
      if (!wasOn) {
        /* the tray is still sliding up; aim where it will stop */
        var bar = tray.el.querySelector('.llcn-tray__bar').getBoundingClientRect();
        var lift = bar.top - (innerHeight - bar.height - (innerWidth < 768 ? 10 + (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--llmt-h')) || 0) : 20));
        r1 = { left: r1.left, top: r1.top - lift, width: r1.width || 38, height: r1.height || 38 };
      }
      var size = r0.width;
      var node = document.createElement('div');
      node.className = 'llcn-fly';
      node.style.width = size + 'px';
      node.style.height = size + 'px';
      node.appendChild(coinClone(c, size));
      document.body.appendChild(node);
      var x0 = r0.left, y0 = r0.top, x1 = r1.left + (r1.width - size) / 2, y1 = r1.top + (r1.height - size) / 2;
      var s1 = (r1.width || 38) / size;
      var xm = x0 + (x1 - x0) * .45, ym = Math.min(y0, y1) - Math.min(160, Math.abs(y1 - y0) * .35 + 60);
      var anim = node.animate([
        { transform: 'translate(' + x0 + 'px,' + y0 + 'px) perspective(700px) rotateX(0deg) scale(1)', easing: 'cubic-bezier(.25,.6,.4,1)' },
        { transform: 'translate(' + xm + 'px,' + ym + 'px) perspective(700px) rotateX(400deg) scale(' + ((1 + s1) / 1.7) + ')', offset: .48, easing: 'cubic-bezier(.5,0,.75,.4)' },
        { transform: 'translate(' + x1 + 'px,' + y1 + 'px) perspective(700px) rotateX(720deg) scale(' + s1 + ')' }
      ], { duration: 700, fill: 'forwards' });
      anim.onfinish = function () { node.remove(); };
      fromCoin.animate([{ transform: 'scale(.9)' }, { transform: 'none' }], { duration: 260, easing: 'cubic-bezier(.34,1.4,.5,1)' });
    });
  }

  /* ---------------------------------------------------------------- basket */
  var Cart = {
    refresh: function () {
      return fetch((cfg.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count], .cart-count, .cart-link__count').forEach(function (el) { el.textContent = cart.item_count; });
          try {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart, bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('ll:cart:updated', { detail: cart }));
          } catch (e) {}
          return cart;
        })
        .catch(function () { return null; });
    },
    add: function (items) {
      return fetch((cfg.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, d: d }; });
      });
    }
  };
  function failText(res) {
    return (res && res.d && (res.d.description || res.d.message)) || 'Sorry, those could not be added to your basket.';
  }

  /* ---------------------------------------------------------------- 6 the viewer */
  var view = (function () {
    var EDGE = 14;
    var el = document.createElement('div');
    el.className = 'llcn-view';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-labelledby', 'llcn-view-title');
    el.setAttribute('aria-hidden', 'true');
    var edges = '';
    for (var k = 0; k < EDGE; k++) edges += '<i class="llcn-3d__edge" style="--k:' + ((k + .5) / EDGE - .5).toFixed(3) + '"></i>';
    el.innerHTML =
      '<div class="llcn-view__card" tabindex="-1">' +
        '<button type="button" class="llcn-x llcn-view__close" data-v-close aria-label="Close">' + ICON.x + '</button>' +
        '<div class="llcn-view__stage">' +
          '<button type="button" class="llcn-view__nav llcn-view__nav--prev" data-v-prev aria-label="Previous coin">' + ICON.left + '</button>' +
          '<div class="llcn-3d" data-v-3d aria-hidden="true"><div class="llcn-3d__coin" data-v-coin>' + edges +
            '<div class="llcn-3d__face llcn-3d__face--back" data-v-back></div><div class="llcn-3d__face" data-v-front></div></div>' +
            '<div class="llcn-3d__shadow" data-v-shadow></div></div>' +
          '<div class="llcn-view__tools"><button type="button" class="llcn-tool" data-v-flip>' + ICON.flip + '<span>Flip it</span></button>' +
            '<span class="llcn-view__hint">' + (fine ? 'Drag the coin to turn it' : 'Drag to turn it') + '</span></div>' +
          '<button type="button" class="llcn-view__nav llcn-view__nav--next" data-v-next aria-label="Next coin">' + ICON.right + '</button>' +
        '</div>' +
        '<div class="llcn-view__info">' +
          '<p class="llcn-view__kick" data-v-kick></p>' +
          '<h2 class="llcn-view__title" id="llcn-view-title" data-v-title></h2>' +
          '<div class="llcn-view__tags" data-v-tags></div>' +
          '<p class="llcn-view__price" data-v-price></p>' +
          '<p class="llcn-view__stock llcn-stock" data-v-stock></p>' +
          '<div class="llcn-view__buy" data-v-buy>' +
            '<div class="llcn-step" role="group" aria-label="Quantity"><button type="button" data-v-less aria-label="One fewer">' + ICON.minus + '</button><output data-v-qty>1</output><button type="button" data-v-more aria-label="One more">' + ICON.plus + '</button></div>' +
            '<button type="button" class="llcn-btn" data-v-add><span>Add to basket</span>' + ICON.arrow + '</button>' +
          '</div>' +
          '<button type="button" class="llcn-link llcn-view__pick" data-v-pick></button>' +
          '<dl class="llcn-facts" data-v-facts></dl>' +
          '<div class="llcn-view__like" data-v-likewrap><h3>More like this</h3><div class="llcn-like" data-v-like></div></div>' +
          '<p class="llcn-view__count" data-v-count></p>' +
        '</div>' +
      '</div>';
    document.body.appendChild(el);
    function q(s) { return el.querySelector(s); }
    var card = q('.llcn-view__card'), stage3d = q('[data-v-3d]'), coinEl = q('[data-v-coin]'), shadow = q('[data-v-shadow]');
    var front = q('[data-v-front]'), back = q('[data-v-back]');
    var api = { cur: null };
    var qty = 1, from = null, pushed = false;
    var ang = { x: 0, y: 0 }, spin = null, tossing = false;

    function faces() { return [front.firstElementChild, back.firstElementChild].filter(Boolean); }
    /* the light is fixed, the coin turns: as it turns, the light crosses its face */
    function lightFromAngles() {
      var ry = ang.y * Math.PI / 180;
      var lx = .5 - Math.sin(ry) * .46, ly = .3 + ang.x / 70;
      faces().forEach(function (f) { Light.set(f, lx, ly); });
    }
    function setAngles() { coinEl.style.transform = 'rotateX(' + ang.x + 'deg) rotateY(' + ang.y + 'deg)'; lightFromAngles(); }
    function sweep(dur, from, to) {
      if (reduce) return;
      faces().forEach(function (f) {
        try { f.animate([{ '--lx': from }, { '--lx': to }], { duration: dur, easing: 'cubic-bezier(.2,.8,.2,1)' }); } catch (e) {}
      });
    }
    function stopSpin() { if (spin) { cancelAnimationFrame(spin); spin = null; } }

    function list() { return shown.length ? shown : coins; }
    function neighbours(c) {
      var L = list(), i = L.indexOf(c);
      if (i < 0) { L = coins; i = L.indexOf(c); }
      return { L: L, i: i, prev: L[(i - 1 + L.length) % L.length], next: L[(i + 1) % L.length] };
    }
    function likeFor(c) {
      var score = function (x) {
        var s = 0;
        if (x.species && x.species === c.species) s += 8;
        if (x.type && x.type === c.type) s += 4;
        if (x.subject === c.subject) s += 1;
        if (x.finishes.some(function (f) { return f !== 'Classic' && c.finishes.indexOf(f) >= 0; })) s += 3;
        if (x.a) s += 2;
        return s;
      };
      return coins.filter(function (x) { return x !== c && x.coin.querySelector('img'); })
        .map(function (x) { return { x: x, s: score(x) }; })
        .sort(function (a, b) { return b.s - a.s || a.x.i - b.x.i; })
        .slice(0, 6).map(function (o) { return o.x; });
    }
    function stockText(c) {
      if (!c.a) return { s: 'out', t: 'Sold out' };
      if (c.stock > 0 && c.stock <= (cfg.low_at || 2)) return { s: 'low', t: c.stock === 1 ? 'Last one in stock' : 'Only ' + c.stock + ' left' };
      return { s: 'in', t: 'In stock, ready to send' };
    }
    function paint(c) {
      api.cur = c;
      var px = stage3d.offsetWidth || 380;
      front.innerHTML = ''; back.innerHTML = '';
      front.appendChild(coinClone(c, px));
      back.appendChild(coinClone(c, px));
      var rim = c.coin.style.getPropertyValue('--rim');
      stage3d.style.setProperty('--rim', rim || '#b9b0a3');
      q('[data-v-kick]').innerHTML = (c.type ? energyIco(c.type) : '') + '<span>' + esc(SUBJECT_WORD[c.subject] || 'Coin') + (c.series ? ' · ' + esc(c.series) : '') + '</span>';
      q('[data-v-title]').textContent = c.base;
      var tags = ['<span class="is-dark">' + (c.big ? 'Oversized' : 'Standard size') + '</span>'];
      c.finishes.forEach(function (f) { if (f !== 'Classic') tags.push('<span>' + esc(f) + '</span>'); });
      c.colours.forEach(function (f) { tags.push('<span>' + esc(f) + '</span>'); });
      q('[data-v-tags]').innerHTML = tags.join('');
      q('[data-v-price]').innerHTML = '<b>' + esc(formatMoney(c.p)) + '</b>' + (c.c > c.p ? '<s>' + esc(formatMoney(c.c)) + '</s>' : '');
      var st = stockText(c), sEl = q('[data-v-stock]');
      sEl.textContent = st.t; sEl.setAttribute('data-s', st.s);
      qty = 1;
      paintBuy();
      api.paintPick();
      var facts = [
        ['Design', esc(c.base)],
        ['Size', c.big ? 'Oversized' : 'Standard'],
        ['Finish', esc(c.finishes.join(', ') + (c.colours.length ? ', ' + c.colours.join(', ').toLowerCase() : ''))]
      ];
      if (c.type) facts.push(['Suits', energyIco(c.type) + (c.type === 'Colorless' ? 'Colourless' : c.type) + ' decks']);
      if (c.series) facts.push(['Series', esc(c.series)]);
      facts.push(['Condition', 'Near mint, official Pokémon TCG']);
      q('[data-v-facts]').innerHTML = facts.map(function (f) { return '<dt>' + f[0] + '</dt><dd>' + f[1] + '</dd>'; }).join('');
      var like = likeFor(c);
      q('[data-v-likewrap]').hidden = !like.length;
      q('[data-v-like]').innerHTML = like.map(function (x) {
        return '<button type="button" data-v-go="' + x.id + '" aria-label="' + esc(x.t) + '" title="' + esc(x.t) + '">' + coinClone(x, 70).outerHTML + '</button>';
      }).join('');
      var nb = neighbours(c);
      q('[data-v-count]').textContent = 'Coin ' + (nb.i + 1) + ' of ' + nb.L.length + (nb.L === shown && shown.length < coins.length ? ' showing' : '');
      q('[data-v-prev]').hidden = q('[data-v-next]').hidden = nb.L.length < 2;
      try {
        var u = new URL(location.href);
        u.searchParams.set('variant', c.id);
        history.replaceState(history.state, '', u.pathname + '?' + u.searchParams.toString() + u.hash);
      } catch (e) {}
    }
    function paintBuy() {
      var c = api.cur, buy = q('[data-v-buy]');
      if (!c.a) {
        buy.innerHTML = '<button type="button" class="llcn-btn llcn-btn--ghost" data-v-watch style="grid-column:1/-1">' + ICON.bell + '<span>' + (watch.on() ? 'Watching for restocks' : 'Tell me about restocks') + '</span></button>';
        return;
      }
      if (!buy.querySelector('[data-v-add]')) {
        buy.innerHTML = '<div class="llcn-step" role="group" aria-label="Quantity"><button type="button" data-v-less aria-label="One fewer">' + ICON.minus + '</button><output data-v-qty>1</output><button type="button" data-v-more aria-label="One more">' + ICON.plus + '</button></div>' +
          '<button type="button" class="llcn-btn" data-v-add><span>Add to basket</span>' + ICON.arrow + '</button>';
      }
      q('[data-v-qty]').textContent = qty;
      q('[data-v-less]').disabled = qty <= 1;
      q('[data-v-more]').disabled = qty >= c.max;
    }
    api.paintPick = function () {
      var c = api.cur, b = q('[data-v-pick]');
      if (!c) return;
      if (!c.a) { b.hidden = true; return; }
      b.hidden = false;
      var n = qtyOf(c.id);
      b.textContent = n ? 'In your picks (' + n + '). Remove it' : 'Or add it to your picks and keep browsing';
      b.setAttribute('data-picked', n ? '1' : '0');
    };

    function spinIn(dir) {
      stopSpin();
      if (reduce) { ang.x = 0; ang.y = 0; setAngles(); return; }
      var a0 = dir < 0 ? 200 : -200;
      coinEl.animate([
        { transform: 'rotateX(0deg) rotateY(' + a0 + 'deg) scale(.86)' },
        { transform: 'rotateX(0deg) rotateY(0deg) scale(1)' }
      ], { duration: 720, easing: 'cubic-bezier(.2,.8,.2,1)' });
      ang.x = 0; ang.y = 0; setAngles();
      sweep(900, dir < 0 ? .05 : .95, .5);
    }
    function toss() {
      if (tossing) return;
      stopSpin();
      if (reduce) return;
      tossing = true;
      var up = (stage3d.offsetWidth || 300) * .42;
      var y0 = Math.round(ang.y / 180) * 180;
      ang.x = 0; ang.y = y0; setAngles();
      var a = coinEl.animate([
        { transform: 'translateY(0) rotateX(0deg) rotateY(' + y0 + 'deg)', easing: 'cubic-bezier(.22,.62,.36,1)' },
        { transform: 'translateY(' + (-up) + 'px) rotateX(900deg) rotateY(' + y0 + 'deg)', offset: .46, easing: 'cubic-bezier(.55,0,.85,.36)' },
        { transform: 'translateY(0) rotateX(1800deg) rotateY(' + y0 + 'deg)', offset: .86, easing: 'cubic-bezier(.3,.6,.4,1)' },
        { transform: 'translateY(' + (-up * .07) + 'px) rotateX(1800deg) rotateY(' + y0 + 'deg)', offset: .93, easing: 'cubic-bezier(.5,0,.8,.5)' },
        { transform: 'translateY(0) rotateX(1800deg) rotateY(' + y0 + 'deg)' }
      ], { duration: 1250 });
      shadow.animate([
        { transform: 'scale(1)', opacity: 1, easing: 'cubic-bezier(.22,.62,.36,1)' },
        { transform: 'scale(.42)', opacity: .35, offset: .46, easing: 'cubic-bezier(.55,0,.85,.36)' },
        { transform: 'scale(1)', opacity: 1, offset: .86 },
        { transform: 'scale(.9)', opacity: .85, offset: .93 },
        { transform: 'scale(1)', opacity: 1 }
      ], { duration: 1250 });
      /* the light plays across the face as it spins */
      faces().forEach(function (f) {
        try {
          f.animate([{ '--lx': .5, '--ly': .3 }, { '--lx': .95, '--ly': .1 }, { '--lx': .05, '--ly': .6 }, { '--lx': .9, '--ly': .2 }, { '--lx': .15, '--ly': .5 }, { '--lx': .5, '--ly': .3 }],
            { duration: 1250, easing: 'linear' });
        } catch (e) {}
      });
      a.onfinish = function () { tossing = false; };
    }

    /* drag to turn: follows the pointer, keeps its momentum, settles face up */
    (function drag() {
      var on = false, sx = 0, sy = 0, ay = 0, ax = 0, lastX = 0, lastT = 0, vel = 0;
      stage3d.addEventListener('pointerdown', function (e) {
        if (tossing || e.button > 0) return;
        stopSpin();
        coinEl.getAnimations && coinEl.getAnimations().forEach(function (a) { a.cancel(); });
        on = true; sx = e.clientX; sy = e.clientY; ay = ang.y; ax = ang.x; lastX = e.clientX; lastT = performance.now(); vel = 0;
        stage3d.classList.add('is-drag');
        try { stage3d.setPointerCapture(e.pointerId); } catch (x) {}
      });
      stage3d.addEventListener('pointermove', function (e) {
        if (!on) {
          /* hovering, not dragging: the light follows the pointer */
          if (fine && !tossing && !spin && e.pointerType === 'mouse') {
            var r = stage3d.getBoundingClientRect();
            var hx = (e.clientX - r.left) / r.width, hy = (e.clientY - r.top) / r.height;
            faces().forEach(function (f) { Light.set(f, hx, hy); });
          }
          return;
        }
        var now = performance.now(), dt = Math.max(1, now - lastT);
        vel = (e.clientX - lastX) / dt * .6;
        lastX = e.clientX; lastT = now;
        ang.y = ay + (e.clientX - sx) * .6;
        ang.x = Math.max(-28, Math.min(28, ax - (e.clientY - sy) * .25));
        setAngles();
      });
      function end() {
        if (!on) return;
        on = false;
        stage3d.classList.remove('is-drag');
        /* degrees per 16 ms frame, from the last pointer speed */
        var v = Math.max(-30, Math.min(30, vel * 16));
        var prev = performance.now();
        (function coast(now) {
          now = now || performance.now();
          var dt = Math.min(48, now - prev) / 16;
          prev = now;
          v *= Math.pow(.94, dt);
          ang.y += v * dt;
          ang.x *= Math.pow(.86, dt);
          setAngles();
          if (Math.abs(v) > .6) { spin = requestAnimationFrame(coast); return; }
          /* settle on the nearest face */
          var target = Math.round(ang.y / 180) * 180, fromY = ang.y, fromX = ang.x, t0 = performance.now(), dur = 520;
          (function settle(n) {
            var p = Math.min(1, ((n || performance.now()) - t0) / dur);
            var e2 = 1 - Math.pow(1 - p, 3);
            ang.y = fromY + (target - fromY) * e2;
            ang.x = fromX * (1 - e2);
            setAngles();
            if (p < 1) spin = requestAnimationFrame(settle); else { ang.y = target % 360; ang.x = 0; setAngles(); spin = null; }
          })();
        })();
      }
      stage3d.addEventListener('pointerup', end);
      stage3d.addEventListener('pointercancel', end);
      stage3d.addEventListener('lostpointercapture', end);
    })();

    function trap(e) {
      if (e.key !== 'Tab' || !el.classList.contains('is-on')) return;
      var f = $$('button:not([disabled]):not([hidden]), [href], input, [tabindex]:not([tabindex="-1"])', card).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function onKey(e) {
      if (!el.classList.contains('is-on')) return;
      if (e.key === 'Escape') { e.preventDefault(); api.close(); }
      else if (e.key === 'ArrowLeft' && !/INPUT|SELECT|TEXTAREA/.test(document.activeElement.tagName)) go(-1);
      else if (e.key === 'ArrowRight' && !/INPUT|SELECT|TEXTAREA/.test(document.activeElement.tagName)) go(1);
      else trap(e);
    }
    document.addEventListener('keydown', onKey);
    function go(dir) {
      var nb = neighbours(api.cur);
      paint(dir < 0 ? nb.prev : nb.next);
      spinIn(dir);
    }

    api.open = function (id, opts) {
      opts = opts || {};
      var c = byId[id];
      if (!c) return;
      var was = el.classList.contains('is-on');
      if (!was) {
        from = document.activeElement;
        el.classList.add('is-on');
        el.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('llcn-lock');
        tray.el.style.visibility = 'hidden';
        try {
          if (!(history.state && history.state.llcnView)) { history.pushState({ llcnView: 1 }, ''); pushed = true; }
        } catch (e) {}
      }
      paint(c);
      if (opts.toss) { ang.x = 0; ang.y = 0; setAngles(); setTimeout(toss, 180); }
      else spinIn(1);
      if (!was) setTimeout(function () { var x = q('[data-v-close]'); if (x) x.focus({ preventScroll: true }); }, 60);
    };
    api.close = function (fromPop) {
      if (!el.classList.contains('is-on')) return;
      stopSpin();
      el.classList.remove('is-on');
      el.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('llcn-lock');
      tray.el.style.visibility = '';
      try {
        var u = new URL(location.href);
        u.searchParams.delete('variant');
        history.replaceState(history.state, '', u.pathname + (u.searchParams.toString() ? '?' + u.searchParams.toString() : '') + u.hash);
        if (pushed && !fromPop) { pushed = false; history.back(); }
      } catch (e) {}
      pushed = false;
      var c = api.cur;
      if (c && c.link && !c.el.hidden) c.link.focus({ preventScroll: true });
      else if (from && from.focus) from.focus({ preventScroll: true });
    };
    window.addEventListener('popstate', function () {
      if (el.classList.contains('is-on')) { pushed = false; api.close(true); return; }
      /* back past a shared ?variant= link: the viewer is shut, so is the URL */
      try {
        var u = new URL(location.href);
        if (u.searchParams.has('variant')) {
          u.searchParams.delete('variant');
          history.replaceState(history.state, '', u.pathname + (u.searchParams.toString() ? '?' + u.searchParams.toString() : '') + u.hash);
        }
      } catch (e) {}
    });

    el.addEventListener('click', function (e) {
      if (e.target === el) { api.close(); return; }
      var t = e.target;
      if (t.closest('[data-v-close]')) api.close();
      else if (t.closest('[data-v-prev]')) go(-1);
      else if (t.closest('[data-v-next]')) go(1);
      else if (t.closest('[data-v-flip]')) toss();
      else if (t.closest('[data-v-less]')) { qty = Math.max(1, qty - 1); paintBuy(); }
      else if (t.closest('[data-v-more]')) { qty = Math.min(api.cur.max, qty + 1); paintBuy(); }
      else if (t.closest('[data-v-go]')) { paint(byId[t.closest('[data-v-go]').getAttribute('data-v-go')]); spinIn(1); card.scrollTop = 0; q('.llcn-view__info').scrollTop = 0; }
      else if (t.closest('[data-v-watch]')) { watch.toggle(); paintBuy(); }
      else if (t.closest('[data-v-pick]')) {
        var c = api.cur;
        if (qtyOf(c.id)) setQty(c.id, 0);
        else { setQty(c.id, qty); api.close(); if (!reduce) fly(c.coin, c); }
      } else if (t.closest('[data-v-add]')) {
        var b = t.closest('[data-v-add]'), c2 = api.cur, n = qty;
        human(function () {
          b.disabled = true; b.classList.add('is-loading');
          Cart.add([{ id: c2.id, quantity: n }]).then(function (res) {
            if (!res.ok) { toast.msg(failText(res), { tone: 'warn' }); return; }
            return Cart.refresh().then(function (cart) {
              toast.cart({ title: c2.base, faces: [c2], meta: (c2.big ? 'Oversized' : 'Standard') + (n > 1 ? ', qty ' + n : ''), price: c2.p * n }, cart);
            });
          }).catch(function () {
            toast.msg('We could not reach the basket. Check your connection and try again.', { tone: 'warn' });
          }).then(function () { b.disabled = false; b.classList.remove('is-loading'); });
        });
      }
    });
    return api;
  })();

  /* surprise me: a random coin from the ones showing, tossed in */
  var lucky = $('[data-lucky]');
  if (lucky) {
    lucky.addEventListener('click', function () {
      var pool = shown.filter(function (c) { return c.a; });
      if (!pool.length) pool = shown.length ? shown : coins;
      var c = pool[Math.floor(Math.random() * pool.length)];
      view.open(c.id, { toss: true });
    });
  }

  /* ---------------------------------------------------------------- 7 heading art */
  (function hero() {
    var art = $('[data-hero]');
    if (!art) return;
    var chosen = [];
    var wanted = String(cfg.hero || '').split(',').map(function (s) { return norm(s); }).filter(Boolean);
    wanted.forEach(function (w) {
      var c = coins.filter(function (x) { return norm(x.t) === w; })[0];
      if (c && chosen.indexOf(c) < 0) chosen.push(c);
    });
    if (chosen.length < 7) {
      /* the dearest in stock, one per Pokémon, skipping look-alikes */
      var seen = {}, tones = [];
      coins.filter(function (c) { return c.a && c.coin.querySelector('img') && chosen.indexOf(c) < 0; })
        .sort(function (a, b) { return b.p - a.p || a.i - b.i; })
        .forEach(function (c) {
          if (chosen.length >= 7) return;
          var sp = c.species || c.t;
          if (seen[sp]) return;
          var tone = c.coin.style.getPropertyValue('--tone');
          var rgb = (tone.match(/[0-9a-f]{2}/gi) || []).map(function (h) { return parseInt(h, 16); });
          if (rgb.length === 3 && tones.some(function (t) { return Math.abs(t[0] - rgb[0]) + Math.abs(t[1] - rgb[1]) + Math.abs(t[2] - rgb[2]) < 60; }) && chosen.length > 2) return;
          seen[sp] = 1;
          if (rgb.length === 3) tones.push(rgb);
          chosen.push(c);
        });
    }
    chosen = chosen.slice(0, 7);
    if (!chosen.length) return;
    /* the middle coin, then six around it on a hexagon (the brand's nut) */
    var slots = [{ cx: 50, cy: 50, d: 38, rot: -4 }];
    var ringR = 32, ang = [-90, -30, 30, 90, 150, 210], sizes = [25, 24, 26, 25, 25, 24], rots = [8, -10, 6, -6, 12, -8];
    ang.forEach(function (a, i) { slots.push({ a: a, d: sizes[i], rot: rots[i] }); });
    var order = [0, 1, 2, 3, 4, 5, 6];
    var nodes = chosen.map(function (c, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'llcn-hcoin';
      b.setAttribute('aria-label', 'View ' + c.t);
      var hc = coinClone(c, i === 0 ? 240 : 150);
      b.appendChild(hc);
      Light.track(hc, i + 2);
      var lab = document.createElement('span');
      lab.className = 'llcn-hcoin__label';
      lab.textContent = c.base + ', ' + formatMoney(c.p);
      b.appendChild(lab);
      b.addEventListener('click', function () { view.open(c.id); });
      return b;
    });
    function place() {
      var ratio = art.clientWidth / Math.max(1, art.clientHeight);
      nodes.forEach(function (b, i) {
        var s = slots[order[i]];
        var cx = s.cx != null ? s.cx : 50 + ringR * Math.cos(s.a * Math.PI / 180);
        var cy = s.cy != null ? s.cy : 50 + ringR * Math.sin(s.a * Math.PI / 180) * ratio;
        b.style.setProperty('--cx', cx.toFixed(2));
        b.style.setProperty('--cy', cy.toFixed(2));
        b.style.setProperty('--d', s.d);
        b.style.setProperty('--rot', s.rot + 'deg');
        b.style.zIndex = i === 0 ? 3 : 1;
      });
    }
    /* ring first, the big one last, so it lands on top */
    nodes.slice(1).concat(nodes[0]).forEach(function (b) { art.appendChild(b); });
    place();
    window.addEventListener('resize', place, { passive: true });
    if (!reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (ents) {
        if (!ents[0].isIntersecting) return;
        io.disconnect();
        var seq = nodes.slice(1).concat(nodes[0]);
        seq.forEach(function (b, i) {
          var rot = b.style.getPropertyValue('--rot');
          b.animate([
            { transform: 'translate(-50%, -50%) perspective(700px) translateY(-70px) rotateX(-540deg) scale(.75) rotate(' + rot + ')', opacity: 0 },
            { transform: 'translate(-50%, -50%) perspective(700px) translateY(0) rotateX(0deg) scale(1) rotate(' + rot + ')', opacity: 1 }
          ], { duration: 820, delay: 90 + i * 75, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'backwards' });
        });
      }, { threshold: .2 });
      io.observe(art);
    }
  })();

  /* ---------------------------------------------------------------- 8 watch
     The same watchlist as every product page: ll_watchlist (handles, capped
     at 100) mirrored to ll_preorder_watch, a snapshot in ll_watchlist_snap,
     and an ll:watchlist:change event. */
  var watch = (function () {
    var WKEY = 'll_watchlist', WLEG = 'll_preorder_watch';
    function read() {
      try {
        var l = JSON.parse(localStorage.getItem(WKEY) || 'null');
        if (Object.prototype.toString.call(l) === '[object Array]') return l;
        var old = JSON.parse(localStorage.getItem(WLEG) || '[]') || [];
        if (Object.prototype.toString.call(old) === '[object Array]') return old;
      } catch (e) {}
      return [];
    }
    function write(list) {
      var clean = [];
      (list || []).forEach(function (h) { if (h && clean.indexOf(h) < 0) clean.push(h); });
      clean = clean.slice(0, 100);
      try { localStorage.setItem(WKEY, JSON.stringify(clean)); localStorage.setItem(WLEG, JSON.stringify(clean)); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('ll:watchlist:change', { detail: { list: clean } })); } catch (e) {}
      try { if (window.LLWatchlistLive && window.LLWatchlistLive.refresh) window.LLWatchlistLive.refresh(); } catch (e) {}
    }
    function on() { return !!P.handle && read().indexOf(P.handle) >= 0; }
    var btns = $$('[data-watch]');
    function sync() {
      var w = on();
      btns.forEach(function (b) {
        b.setAttribute('aria-pressed', w ? 'true' : 'false');
        var lab = b.querySelector('[data-watch-label]');
        if (lab) {
          if (!lab.hasAttribute('data-off')) lab.setAttribute('data-off', lab.textContent);
          lab.textContent = w ? 'Watching the coins' : lab.getAttribute('data-off');
        }
      });
    }
    function toggle() {
      var list = read(), i = list.indexOf(P.handle), now;
      var snaps;
      try { snaps = JSON.parse(localStorage.getItem('ll_watchlist_snap') || '{}') || {}; } catch (e) { snaps = {}; }
      if (i >= 0) {
        list.splice(i, 1); now = false; delete snaps[P.handle];
        try { if (window.LLWatchlistLive && window.LLWatchlistLive.stop) window.LLWatchlistLive.stop(P.handle); } catch (e) {}
      } else {
        list.push(P.handle); now = true;
        var cheapest = coins.filter(function (c) { return c.a; }).sort(function (a, b) { return a.p - b.p; })[0] || coins[0];
        snaps[P.handle] = { handle: P.handle, title: P.title, url: P.url, image: P.image, price: cheapest.p, available: coins.some(function (c) { return c.a; }) };
      }
      try { localStorage.setItem('ll_watchlist_snap', JSON.stringify(snaps)); } catch (e) {}
      write(list);
      sync();
      toast.watch(now);
    }
    btns.forEach(function (b) { b.addEventListener('click', toggle); });
    document.addEventListener('ll:watchlist:change', sync);
    sync();
    return { on: on, toggle: toggle };
  })();

  /* ---------------------------------------------------------------- toasts
     The product page's toast (its styles live in ll-product.css, loaded for
     every product template), so coins report exactly like everything else. */
  var toast = (function () {
    var host = null, cur = null, timer = null, left = 0, started = 0;
    function ensure() {
      if (host) return host;
      host = document.querySelector('.llp-toasts');
      if (!host) {
        host = document.createElement('div');
        host.className = 'llp-toasts';
        host.setAttribute('aria-live', 'polite');
        host.setAttribute('aria-atomic', 'true');
        document.body.appendChild(host);
      }
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && cur) close(); });
      return host;
    }
    function close() {
      clearTimeout(timer);
      if (!cur) return;
      var el = cur; cur = null;
      el.classList.remove('is-in');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 260);
    }
    function arm(ms) { clearTimeout(timer); left = ms; started = Date.now(); timer = setTimeout(close, ms); }
    function show(html, opts) {
      opts = opts || {};
      ensure();
      if (cur) { var old = cur; cur = null; if (old.parentNode) old.parentNode.removeChild(old); }
      var el = document.createElement('div');
      el.className = 'llp-toast' + (opts.tone ? ' llp-toast--' + opts.tone : '');
      el.setAttribute('role', opts.tone === 'warn' ? 'alert' : 'status');
      var ms = opts.ms || 6000;
      el.innerHTML = html + '<button type="button" class="llp-toast__x" aria-label="Close">' + ICON.x + '</button>' +
        (reduce ? '' : '<span class="llp-toast__timer" style="animation: llp-timer ' + ms + 'ms linear forwards"></span>');
      host.appendChild(el);
      cur = el;
      el.querySelector('.llp-toast__x').addEventListener('click', close);
      function pause() { if (el !== cur) return; clearTimeout(timer); left = Math.max(1200, left - (Date.now() - started)); el.classList.add('is-paused'); }
      function resume() { if (el !== cur) return; el.classList.remove('is-paused'); arm(left); }
      el.addEventListener('mouseenter', pause);
      el.addEventListener('mouseleave', resume);
      el.addEventListener('focusin', pause);
      el.addEventListener('focusout', function (e) { if (!el.contains(e.relatedTarget)) resume(); });
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-in'); }); });
      arm(ms);
      return el;
    }
    function shipBlock(cart) {
      var th = cfg.free_ship || 0;
      if (!cart || !th) return '';
      var total = cart.total_price || 0;
      if (total >= th) return '<div class="llp-toast__ship is-free"><p>Free UK delivery unlocked on this basket.</p><div class="llp-toast__ship-bar"><i style="width:100%"></i></div></div>';
      var pct = Math.max(4, Math.min(100, Math.round(total / th * 100)));
      return '<div class="llp-toast__ship"><p><b>' + esc(formatMoney(th - total)) + '</b> away from free UK delivery.</p><div class="llp-toast__ship-bar"><i style="width:' + pct + '%"></i></div></div>';
    }
    function faces(list) {
      var f = (list || []).filter(Boolean).slice(0, 3);
      return '<span class="llp-toast__img llcn-tcoins" data-n="' + f.length + '">' + f.map(function (c) { return coinClone(c, 44).outerHTML; }).join('') + '</span>';
    }
    function cart(item, cartObj) {
      var count = cartObj && cartObj.item_count;
      var html = '<p class="llp-toast__head">' + ICON.check + '<span>Added to your basket</span></p>' +
        '<div class="llp-toast__body">' + faces(item.faces) +
          '<div><p class="llp-toast__t">' + esc(item.title) + '</p>' +
          '<p class="llp-toast__m">' + (item.meta ? esc(item.meta) + ' · ' : '') + '<b>' + esc(formatMoney(item.price)) + '</b></p></div>' +
        '</div>' + shipBlock(cartObj) +
        '<div class="llp-toast__act"><a class="llp-toast__btn" href="' + esc(cfg.cart_url || '/cart') + '">View basket' + (count ? ' (' + count + ')' : '') + '</a>' +
        '<a class="llp-toast__btn llp-toast__btn--go" href="/checkout">Checkout</a></div>';
      return show(html, { ms: 7000 });
    }
    function watchT(on) {
      var html = '<p class="llp-toast__head">' + ICON.bell + '<span>' + (on ? 'Watching the coins for you' : 'Removed from your watchlist') + '</span></p>' +
        '<div class="llp-toast__body llp-toast__body--text"><p class="llp-toast__msg">' +
        (on ? 'We will tell you when new designs land and when sold out coins come back.' : 'You will not get coin alerts any more.') + '</p></div>' +
        '<div class="llp-toast__act llp-toast__act--one"><a class="llp-toast__btn" href="' + esc(cfg.watch_url || '/pages/watchlist') + '">View your watchlist</a></div>';
      return show(html, { tone: 'watch', ms: 5000 });
    }
    function msg(text, opts) {
      opts = opts || {};
      var html = '<p class="llp-toast__head">' + (opts.tone === 'warn' ? ICON.warn : ICON.check) + '<span>' + esc(opts.head || (opts.tone === 'warn' ? 'Not added' : 'Done')) + '</span></p>' +
        '<div class="llp-toast__body llp-toast__body--text"><p class="llp-toast__msg">' + esc(text) + '</p></div><div style="height:14px"></div>';
      return show(html, { tone: opts.tone, ms: opts.ms || 4500 });
    }
    return { cart: cart, watch: watchT, msg: msg, close: close };
  })();

  /* ---------------------------------------------------------------- the human check
     The product page's hCaptcha, branded, once per session: the same site key
     and the same session flag (cap_atc_ok), so a shopper who solved it on any
     product page is not asked again here. Client-side friction only; the
     limits that cannot be bypassed live at checkout. */
  var human = (function () {
    if (window.LLEnsureHuman) return window.LLEnsureHuman;
    var KEY = 'ff761d2e-961a-4122-8f54-be50fe9ee1c8';
    var hc = { id: null, cb: null, el: null, last: null };
    function passed() { try { return sessionStorage.getItem('cap_atc_ok') === '1'; } catch (e) { return false; } }
    function load(cb) {
      if (window.hcaptcha && window.hcaptcha.render) return cb();
      if (!document.querySelector('script[src*="hcaptcha.com/1/api.js"]')) {
        var sc = document.createElement('script');
        sc.src = 'https://js.hcaptcha.com/1/api.js?render=explicit';
        sc.async = true;
        document.head.appendChild(sc);
      }
      var tries = 0;
      var t = setInterval(function () {
        if (window.hcaptcha && window.hcaptcha.render) { clearInterval(t); cb(); }
        else if (++tries > 75) { clearInterval(t); hide(); toast.msg('The quick check could not load. Please try again in a moment.', { tone: 'warn', head: 'Check not loaded' }); }
      }, 200);
    }
    function hide() {
      if (!hc.el) return;
      hc.el.hidden = true;
      if (!document.querySelector('.llcn-view.is-on')) document.documentElement.classList.remove('llcn-lock');
      if (hc.last && hc.last.focus) hc.last.focus();
    }
    function modal() {
      if (hc.el) return hc.el;
      var o = document.createElement('div');
      o.className = 'llp-hc';
      o.hidden = true;
      o.setAttribute('role', 'dialog');
      o.setAttribute('aria-modal', 'true');
      o.setAttribute('aria-labelledby', 'llcn-hc-title');
      o.innerHTML = '<div class="llp-hc__card">' +
        '<div class="llp-hc__top"><p class="llp-hc__kicker">One moment</p><h2 class="llp-hc__title" id="llcn-hc-title">Quick check</h2></div>' +
        '<div class="llp-hc__body"><p>Tick the box so we know you are a collector, not a bot. You will only be asked once this visit.</p>' +
        '<div class="llp-hc__widget" id="llcn-hc-widget"></div>' +
        '<button type="button" class="llp-hc__cancel" data-hc-cancel>Not now</button></div></div>';
      document.body.appendChild(o);
      o.querySelector('[data-hc-cancel]').addEventListener('click', function () { hc.cb = null; hide(); try { window.hcaptcha.reset(hc.id); } catch (e) {} });
      o.addEventListener('click', function (e) { if (e.target === o) o.querySelector('[data-hc-cancel]').click(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !o.hidden) o.querySelector('[data-hc-cancel]').click(); });
      hc.el = o;
      return o;
    }
    return function (cb) {
      if (passed()) return cb();
      hc.cb = cb;
      hc.last = document.activeElement;
      load(function () {
        var o = modal();
        o.hidden = false;
        document.documentElement.classList.add('llcn-lock');
        if (hc.id === null) {
          hc.id = window.hcaptcha.render('llcn-hc-widget', {
            sitekey: KEY,
            callback: function () {
              try { sessionStorage.setItem('cap_atc_ok', '1'); } catch (e) {}
              hide();
              try { window.hcaptcha.reset(hc.id); } catch (e) {}
              if (hc.cb) { var f = hc.cb; hc.cb = null; f(); }
            }
          });
        }
        var cancel = o.querySelector('[data-hc-cancel]');
        if (cancel) cancel.focus({ preventScroll: true });
      });
    };
  })();

  /* ---------------------------------------------------------------- go */
  buildControls();
  apply();
  coins.forEach(function (c) { paintTile(c); });
  tray.render();

  /* ?variant= opens that coin (links from Google Shopping, the basket, shares) */
  try {
    var vid = new URL(location.href).searchParams.get('variant');
    if (vid && byId[vid]) {
      var c0 = byId[vid];
      c0.el.scrollIntoView({ block: 'center' });
      setTimeout(function () { view.open(c0.id); }, 250);
    }
  } catch (e) {}
})();
